const config = {
    baseAppUrl: {
        $default: 'https://localhost:3000',
        staging: 'https://dev-merch.spyamz.com',
        production: 'https://merch.spyamz.com',
    },
    baseUrl: {
        $default: 'http://localhost:3001',
        staging: 'https://dev-admin.spyamz.com',
        production: 'https://admin.spyamz.com',
    },
    baseAPI: {
        $default: 'https://dev.spyamzservices.com',
        staging: 'https://dev.spyamzservices.com',
        production: 'https://prod.spyamzservices.com',
    },
    baseAdminAPI: {
        $default: 'https://dev-admin.spyamzservices.com',
        staging: 'https://dev-admin.spyamzservices.com',
        production: 'https://prod-admin.spyamzservices.com',
    },
    baseAdminAffiliate: {
        $default: 'https://dev.spyamzservices.com/affiliate',
        staging: 'https://dev.spyamzservices.com/affiliate',
        production: 'https://prod.spyamzservices.com/affiliate'
    },
    basePaymentAPI:{
        $default: 'https://dev.spyamzservices.com/payment',
        staging: 'https://dev.spyamzservices.com/payment',
        production: 'https://prod.spyamzservices.com/payment'
    }
};

const _getEnvironment = () => {
    return process.env.REACT_APP_ENV || 'development';
};

export default (key, defaultValue = null) => {
    if (!config.hasOwnProperty(key)) {
        return defaultValue;
    }

    const env = _getEnvironment();
    const _dataConfig = config[key];

    return _dataConfig[env] ? _dataConfig[env] : _dataConfig['$default'] || defaultValue;
};


// WEBPACK FOOTER //
// ./src/helpers/common/getEnv.js